import { ReactNode } from 'react';
import { useSelector } from 'react-redux';

import { selectThemeMode } from 'app/modules/theme/selectors';
import { U21ComponentLibrary } from 'app/shared/u21-ui/components';
import { consoleError } from 'app/shared/utils/console';

interface Props {
  children: ReactNode;
}

export const U21ComponentLibraryWrapper = ({ children }: Props) => {
  const themeMode = useSelector(selectThemeMode);
  return (
    <U21ComponentLibrary reportError={consoleError} mode={themeMode}>
      {children}
    </U21ComponentLibrary>
  );
};
